import { useNetwork } from './network';

export const useAuth = () => {
  const network = useNetwork();

  const getCurrentLoggedUserParams = async () => {
    const url = network.getBaseUrl() + '/api/sdm-user-rest-resource';
    const obRes = await network.get(url);
    return obRes.data;
  };

  const getAccessToken = async () => {
    // prettier-ignore
    //##token##
    /* eslint-disable */
    try {
      const token = await network.get(network.getBaseUrl() + '/api/sdm-access/token');
      return token.data;
    } catch (e) {
      console.log(e);
    }
    return null;
    /* eslint-enable */
  };

  const getEmailFromUrl = () => {
    if (location.search) {
      const params = new URLSearchParams(location.search);
      return params.get('email') || false;
    }
    return false;
  };

  return { getCurrentLoggedUserParams, getAccessToken, getEmailFromUrl };
};
